bovoApp.
  factory('TrackingAd', ['$http', function ($http) {
    return {
      all: function () {
        return $http.get('api/tracking-ads');
      },
      get: function (id) {
        return $http.get('api/tracking-ad/' + id);
      },
      stats: function (id, days) {
        return $http.get('api/tracking-ad/' + id + '/stats' + (days ? ('?days=' + days) : ''));
      },
      new: function () {
        return $http.get('api/new-tracking-ad');
      },
      delete: function (id) {
        return $http.delete('api/delete-tracking-ad/' + id);
      },
      save: function (data) {
        return $http.post('api/save-tracking-ad', data);
      },
      update: function (data) {
        return $http.post('api/update-tracking-ad', data);
      },
      uploadMedia: function (file, target) {
        var fd = new FormData();
        fd.append('file', file);
        fd.append('target', target || 'web');
        return $http.post('api/upload-tracking-ad-media', fd, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          }
        });
      }
    };
  }]);
